import PropTypes from "prop-types";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

function capitalize(s) {
  if (s !== "") {
    return s[0].toUpperCase() + s.slice(1);
  } else {
    return "";
  }
}

const fontWeight = "700";
export default function VolumeScenarioReport({ volumes }) {
  return (
    <div>
      <Table sx={{ margin: "auto", maxWidth: "600px" }}>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell sx={{ fontWeight }}>Left</TableCell>
            <TableCell sx={{ fontWeight }}>Through</TableCell>
            <TableCell sx={{ fontWeight }}>Right</TableCell>
            <TableCell sx={{ fontWeight }}>Truck %</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(volumes)
            .filter((key) => key !== "passengersPerVehicle")
            .map((key) => (
              <TableRow key={key}>
                <TableCell sx={{ fontWeight }}>{capitalize(key)}</TableCell>
                <TableCell>{volumes[key].left}</TableCell>
                <TableCell>{volumes[key].through}</TableCell>
                <TableCell>{volumes[key].right}</TableCell>
                <TableCell>{volumes[key].truckPct}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </div>
  );
}

VolumeScenarioReport.propTypes = {
  volumes: PropTypes.object.isRequired,
};
